export const getMeta = (fetch: Client.HttpClient) => () =>
  fetch.get<Sentinel.Goals.GetGoalConfigResponse>("/api/goalsconfig");

export const updateMeta =
  (fetch: Client.HttpClient) => (data: Sentinel.Goals.UpdateRequest) =>
    fetch.post("/api/goalsconfig", { body: data });
